module.exports = __webpack_public_path__ + "static/media/crocodile(18).342de7d6.PNG";